import type { ViewDateSourceDTO, ViewDateSourceUpsertDTO } from '@tempo-io/roadmap-dto';
import { tempoApi } from '@/common/api/tempoApi';

const fetchDateSource = async (viewId: number): Promise<ViewDateSourceDTO> => {
  const response = await tempoApi().get(`api/v1/loop-visualization/view/${viewId}/date-source`);
  return response.json<ViewDateSourceDTO>();
};

const upsertDateSource = async (viewId: number, data: ViewDateSourceUpsertDTO): Promise<void> => {
  await tempoApi().put(`api/v1/loop-visualization/view/${viewId}/date-source`, { json: data });
};

export const DateSourceApi = {
  fetchDateSource,
  upsertDateSource,
} as const;
